// extracted by mini-css-extract-plugin
var _1 = "EmailGoogleTemplateExternalVariablesList-moduleitemsWrapper__kKtn_";
var _2 = "EmailGoogleTemplateExternalVariablesList-modulelabel__FtDEy";
var _3 = "EmailGoogleTemplateExternalVariablesList-moduletemplateName__t6SwV";
var _4 = "EmailGoogleTemplateExternalVariablesList-moduletemplateNameContainer__Qg608";
var _5 = "EmailGoogleTemplateExternalVariablesList-modulevariableItem__k9Q0P";
var _6 = "EmailGoogleTemplateExternalVariablesList-modulevariables__i9EOW";
export { _1 as "itemsWrapper", _2 as "label", _3 as "templateName", _4 as "templateNameContainer", _5 as "variableItem", _6 as "variables" }
